<div class="navblock">
  <button class="btnadd" (click)="openCreateModal()">{{'Add command'|translate }}</button>
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{'Find by name' | translate }}" [(ngModel)]="nameFilter"
           (input)="onTermChange($event)"/>
  </div>
</div>
<div class="tablewrap admindrivers">
  <div class="table">
    <table fixedcols="[0, 1, 2]" id="exporttable">
      <tr>
        <th>
            <switch-all-checkbox [items]="objects | groupFilter : filter" />
        </th>
        <th>
          {{'Command'|translate }}
        </th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let command of objects | groupFilter : filter" [class.checked]="command.IsChecked">
        <td>
          <input type="checkbox" [(ngModel)]="command.IsChecked"/>
        </td>
        <td>{{command.Name}}</td>
        <td>
          <button class="btn_img btn_edit" (click)="editCommand(command)" data-toggle="tooltip" data-placement="top" title="{{'Edit'|translate}}"></button>
          <button class="btn_img btn_trush" (click)="deleteObject(command.Id)" data-toggle="tooltip" data-placement="top" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [items]="objects | groupFilter : filter"></app-footer-component>
<template #mgmtDialog></template>

<script>
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
</script>